import { FC } from 'react';
import { Content } from '@prismicio/client';
import { JSXMapSerializer, PrismicRichText } from '@prismicio/react';

import { TableHead, TableRow, TableWrapper } from '@/components';

import styles from './onToTwo.module.scss';
import { Simplify } from '../../../prismicio-types';

const headComponents: JSXMapSerializer = {
  paragraph: ({ children }) => <p className={styles.headText}>{children}</p>,
};

const rowTitleComponents: JSXMapSerializer = {
  paragraph: ({ children }) => <p className={styles.rowTitle}>{children}</p>,
};

type Props = {
  data: Simplify<Content.PolicyTableSliceOnToTwoPrimary>;
};

export const OnToTwoTable: FC<Props> = ({ data }) => {
  return (
    <TableWrapper>
      <TableHead className={styles.head}>
        {data.head.map((item, index) => (
          <PrismicRichText
            field={item.title}
            key={`${item.title[0]?.type}-${index}`}
            components={headComponents}
          />
        ))}
      </TableHead>
      <TableWrapper>
        {data.body.map((item, index) => {
          const hasDescription = 'description' in item;

          return (
            <TableRow
              key={`${item.title[0]?.type}-${index}`}
              className={styles.row}
            >
              <PrismicRichText
                field={item.title}
                components={rowTitleComponents}
              />
              {hasDescription && (
                <div className={styles.descriptionWrapper}>
                  <PrismicRichText field={item.description} />
                </div>
              )}
            </TableRow>
          );
        })}
      </TableWrapper>
    </TableWrapper>
  );
};
